import { useState } from "react";

interface UsePaymentProcessReturn {
  paymentProcess: string | null;
  isScreenLoading: boolean;
  isBTNLoading: boolean;
  isWirePayment: boolean;
  isAddNewCard: boolean;
  invoiceSlug: string;
  email: string;
  leadId: string;
  accountId: string;
  amountDisplay: number;
  orderId: number;
  invoiceNumber: string;
  isMultipleSubscription: boolean;
  setInvoiceNumber: (invoiceNumber: string) => void;
  setOrderId: (id: number) => void;
  setPaymentProcess: (status: string | null) => void;
  setIsScreenLoading: (loading: boolean) => void;
  setIsBTNLoading: (loading: boolean) => void;
  setIsWirePayment: (wire: boolean) => void;
  setIsAddNewCard: (add: boolean) => void;
  setInvoiceSlug: (slug: string) => void;
  setEmail: (email: string) => void;
  setLeadId: (id: string) => void;
  setAccountId: (id: string) => void;
  setAmountDisplay: (amount: number) => void;
  resetPaymentProcess: () => void;
  setIsMultipleSubscription: (isMultiple: boolean) => void;
}

export const usePaymentProcess = (): UsePaymentProcessReturn => {
  const [paymentProcess, setPaymentProcess] = useState<string | null>(null);
  const [isScreenLoading, setIsScreenLoading] = useState<boolean>(false);
  const [isBTNLoading, setIsBTNLoading] = useState<boolean>(false);
  const [isWirePayment, setIsWirePayment] = useState<boolean>(false);
  const [isAddNewCard, setIsAddNewCard] = useState<boolean>(false);
  const [invoiceSlug, setInvoiceSlug] = useState<string>("");
  const [orderId, setOrderId] = useState<number>(0);
  const [email, setEmail] = useState<string>("");
  const [leadId, setLeadId] = useState<string>("");
  const [accountId, setAccountId] = useState<string>("");
  const [amountDisplay, setAmountDisplay] = useState<number>(0);
  const [invoiceNumber, setInvoiceNumber] = useState<string>("");
  const [isMultipleSubscription, setIsMultipleSubscription] = useState<boolean>(false);

  const resetPaymentProcess = () => {
    setPaymentProcess(null);
    setIsScreenLoading(false);
    setIsBTNLoading(false);
    setIsWirePayment(false);
    setInvoiceSlug("");
    setOrderId(0);
    setEmail("");
    setLeadId("");
    setAccountId("");
    setAmountDisplay(0);
    setInvoiceNumber("");
    setIsMultipleSubscription(false);
  };

  return {
    paymentProcess,
    isScreenLoading,
    isBTNLoading,
    isWirePayment,
    isAddNewCard,
    invoiceSlug,
    email,
    leadId,
    accountId,
    amountDisplay,
    orderId,
    invoiceNumber,
    isMultipleSubscription,
    setIsMultipleSubscription,
    setInvoiceNumber,
    setOrderId,
    setPaymentProcess,
    setIsScreenLoading,
    setIsBTNLoading,
    setIsWirePayment,
    setIsAddNewCard,
    setInvoiceSlug,
    setEmail,
    setLeadId,
    setAccountId,
    setAmountDisplay,
    resetPaymentProcess,
  };
};
